import MojitoPresentation from 'mojito/presentation';
import MojitoCore from 'mojito/core';
import PrebuiltBetClassic from 'modules/prebuilt-bets/prebuilt-bet/view/classic/index.js';
import PrebuiltBetUtils from 'modules/prebuilt-bets/prebuilt-bet/utils.js';
import { useBetBuilderAnalyticsContext } from 'modules/prebuilt-bets/prebuilt-bet/hooks/index.js';

const { getSeparatorTranslationKey } = MojitoPresentation.Utils.ParticipantSeparator;
const { FlexPane, Image, Text, DateTime, NeutralVenueIndicator, ParticipantIconsInline } =
    MojitoPresentation.Components;
const AnalyticsContextExtender = MojitoCore.Presentation.AnalyticsContext.ContextExtender;

const Header = ({ config, event, promotionText, stringResolver }) => (
    <FlexPane class="ta-PrebuiltBetHeader" config={config.headerContainer}>
        {config.showMatchAccaIcon && <Image config={config.matchAccaIcon} />}
        <FlexPane config={config.headerTextContainer}>
            {Boolean(promotionText) && <Text config={config.promotionText}>{promotionText}</Text>}
            <ParticipantIconsInline
                participants={event?.participants}
                sportId={event?.sportId}
                homeAway={event?.homeAway}
                separator={stringResolver.resolveString(
                    getSeparatorTranslationKey(event?.homeAway)
                )}
                config={config.participantsIconInline}
            />
            <FlexPane config={config.timeAndTypeContainer}>
                <Text config={config.startTime}>
                    <DateTime config={config.startTimeFormat} dateTime={event?.startTime} />
                </Text>
                <Text config={config.typeName}>{` - ${event?.typeName}`}</Text>
            </FlexPane>
        </FlexPane>
        {event?.neutral && <NeutralVenueIndicator config={config.neutralVenueIndicator} />}
    </FlexPane>
);

const PrebuiltBetBuilderClassic = props => {
    const {
        mojitoTools: { config, style, stringResolver },
        event,
        market,
        promotionText,
        boostedMarket,
        onEventClick,
        imgUrl,
        colorMode,
    } = props;

    const cardConfig = PrebuiltBetUtils.resolveCardDetails(style, colorMode || config.view.mode);
    const analyticsContext = useBetBuilderAnalyticsContext(boostedMarket);

    return (
        <AnalyticsContextExtender value={analyticsContext} pathSeparator={'_'} pathReverse={true}>
            <PrebuiltBetClassic
                config={cardConfig.view}
                market={market}
                boostedMarket={boostedMarket}
                event={event}
                onEventClick={onEventClick}
                imgUrl={imgUrl}
                colorMode={colorMode}
                class={'ta-PrebuiltBetBuilder'}
            >
                {cardConfig.view.showCardHeader && (
                    <Header
                        config={cardConfig}
                        event={event}
                        promotionText={promotionText}
                        stringResolver={stringResolver}
                    />
                )}
            </PrebuiltBetClassic>
        </AnalyticsContextExtender>
    );
};

PrebuiltBetBuilderClassic.getStyle = (config, mode, merge) =>
    PrebuiltBetUtils.buildCardDetails(config, 'prebuiltBetBuilderDetailsDark', merge);

export default PrebuiltBetBuilderClassic;
